module.exports = __webpack_public_path__ + "img/illustration-john.e9113ebb.png";